import React from "react";
import PropTypes from "prop-types";
import { Box, Icons, Stack, Typography } from "@curves/ui-base";
import { ProductInfo } from "@curves/ui-shared";
import { parseDate } from "@Util/moment.util";
import { formatCurrencyFn } from "@Util/utils";

const DISPLAY_DATE_BY_SLASH = "YYYY/MM/DD";

const ShopStockSummaryCard = ({ product = {}, lastInventoryDate, defaultPrice, sellableQty, canAdjust = false, onEditSellableQty, className = "" }) => {
	const displayLastInventoryDate = lastInventoryDate ? parseDate(lastInventoryDate, DISPLAY_DATE_BY_SLASH) : "—";
	const displayDefaultPrice = defaultPrice != null ? formatCurrencyFn(defaultPrice, { symbol: "$" }) : "—";
	const displaySellableQty = sellableQty != null ? sellableQty : "—";

	return (
		<Box className={`stock-summary-card ${className}`}>
			<Stack direction="row" justifyContent="space-between" alignItems="center">
				<Box className="stock-summary-product">
					<ProductInfo product={product} className="stock-summary-product-info" imageSize={120} />
				</Box>
				<Box className="stock-summary-meta">
					<Box className="stock-summary-meta-item">
						<Typography variant="body2" className="stock-summary-meta-label">
							上次盤點日
						</Typography>
						<Typography variant="body1" className="stock-summary-meta-value">
							{displayLastInventoryDate}
						</Typography>
					</Box>
					<Box className="stock-summary-meta-item">
						<Typography variant="body2" className="stock-summary-meta-label">
							預設販售價格
						</Typography>
						<Typography variant="body1" className="stock-summary-meta-value">
							{displayDefaultPrice}
						</Typography>
					</Box>
					<Box className="stock-summary-meta-item">
						<Typography variant="body2" className="stock-summary-meta-label">
							可販售數量
						</Typography>
						<Box className="stock-summary-meta-value">
							<Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} onClick={canAdjust ? onEditSellableQty : undefined} style={{ cursor: canAdjust ? "pointer" : "default" }}>
								<Typography variant="body1" className="mb-0">
									{displaySellableQty}
								</Typography>
								<span style={{ visibility: canAdjust ? "visible" : "hidden", display: "inline-flex" }}>
									<Icons.Exclamation htmlColor="#f44336" fontSize="small" />
								</span>
							</Stack>
						</Box>
					</Box>
				</Box>
			</Stack>
		</Box>
	);
};

ShopStockSummaryCard.propTypes = {
	product: PropTypes.shape({
		sku: PropTypes.string,
		name: PropTypes.string,
		spec: PropTypes.string,
		category: PropTypes.string,
		imageUrl: PropTypes.string,
	}),
	lastInventoryDate: PropTypes.string,
	defaultPrice: PropTypes.number,
	sellableQty: PropTypes.number,
	canAdjust: PropTypes.bool,
	onEditSellableQty: PropTypes.func,
	className: PropTypes.string,
};

export default ShopStockSummaryCard;
